import React from 'react'
import Switch from '@mui/material/Switch'
import { styled } from '@mui/material/styles'

export const CustomSwitch = styled(({ width, height, color, ...props }) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
    data-testid="input-switch-toggle"
  />
))(({ theme, width = 44, height = 24, color }) => {
  // Dynamically calculate the size of the "thumb" (20px less than height)
  const thumbSize = height - 4

  // Translation distance based on the width and height of the switch
  const translationX = width - thumbSize - 4 // Thumb movement distance

  return {
    width, // Dynamic width of the switch
    height, // Dynamic height of the switch
    padding: 0,
    cursor: 'pointer',
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: `translateX(${translationX}px)`, // Proportional movement based on size
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: color || '#003082',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.2,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: color || '#003082',
        border: '6px solid #003082',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: thumbSize, // Use dynamically calculated thumb size
      height: thumbSize, // Use dynamically calculated thumb size
    },
    '& .MuiSwitch-track': {
      borderRadius: height / 2, // Dynamic border radius based on height
      backgroundColor: '#afafaf',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }
})
